function makeColumns(heads) {
  let colspanSum = 0;

  return heads.reduce((acc, head) => {
    const { mode, dayName } = head.dataset;

    acc[dayName] = {
      name: dayName,
      modes: {
        [mode]: {
          rows: {},
          name: mode,
          units: 'Metric',
          start: colspanSum,
          colspan: head.colSpan,
          end: (colspanSum += head.colSpan),
        },
      },
    };

    return acc;
  }, {});
}

export default makeColumns;
